import React from 'react';
import { ProofColumnHeaderTitle } from 'flux/stores/cuesheet/CuesheetConstants';
import ColumnMenu from 'main/components/show/cuesheet/columnHeaderCell/proofColumnMenu.jsx';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classnames from 'classnames';
import CuesheetColumnActions from 'shared/flux/actions/cuesheet/CuesheetColumnActions';
import role from 'shared/lib/role';

/**
 * Proof header cell
 *
 */
export default React.createClass({
  displayName: 'ProofColumnHeaderCell',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    let { proofOfPerformanceTracking } = this.props;
    let hasAdminRole = this._hasEventAdminRole();

    return (
      <WithTooltip placement="top" tip={TooltipConstants.CSProofHeaderCell}>
        <div className="cs-header-cell">
          {ProofColumnHeaderTitle}

          <div
            className={classnames('proof-auto-ts-icon', {
              'proof-auto-ts-active': proofOfPerformanceTracking,
              'proof-readonly': !hasAdminRole,
            })}
            onClick={() => {
              if (hasAdminRole) {
                if (proofOfPerformanceTracking)
                  return CuesheetColumnActions.disableProofTracking();
                return CuesheetColumnActions.enableProofTracking();
              }
            }}
          >
            <Icon name="feed" />
          </div>

          <div className="caret-right">
            <ColumnMenu {...this.props} />
          </div>
        </div>
      </WithTooltip>
    );
  },

  _hasEventAdminRole() {
    let params = this.context.router.state.params;
    let { teamId, eventId } = params;
    let { user } = this.props;

    if (!user) return;

    return role.hasEventAdminRole(user, teamId, eventId);
  },
});
